import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { api } from "helpers/api_url";

export interface StockOverviewQuery {
  page: number;
  pageSize: number;
  search?: string;
  sort?: string;
  order?: "asc" | "desc" | "";
  filters?: any;
}

export const fetchStockOverview = createAsyncThunk(
  "inventory/stockOverview",
  async (query: StockOverviewQuery, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();

      params.append("page", String(query.page));
      params.append("pageSize", String(query.pageSize));
      if (query.search) params.append("search", query.search);
      // if (query.sort) params.append("sort", query.sort);
      // if (query.order) params.append("order", query.order);
       if (query.sort) {
      const orderingValue = query.order === "desc" ? `-${query.sort}` : query.sort;
      params.append("ordering", orderingValue);
    }

      // Filters
      if (Array.isArray(query.filters)) {
        query.filters.forEach((f: any) => {
          if (f.filterField && f.filterValue !== undefined) {
            params.append(f.filterField, f.filterValue);
          }
        });
      }

      const response = await Axios.get(`/inventory/in-stock`, { params });
      const api = response.data;

      return {
        data: api.data || [],
        totalRecords: api.count || 0,  // <-- FIXED
        page: query.page,              // backend does NOT return page
        pageSize: query.pageSize,      // backend does NOT return pageSize
      };
    } catch (err: any) {
      return rejectWithValue(err?.response?.data || "Network Error");
    }
  }
);

export const exportInstockCSV = async ({
  sort,
  order,
  search,
  filters,
  warehouse_id,
}: {
  sort: any;
  order: any;
  search: any;
  filters?: { filterField: string; filterValue: any }[];
   warehouse_id?: string | number | null; // 
}) => {
  const params = new URLSearchParams();
  if (search) params.append("search", search);

   if (warehouse_id) {
    params.append("warehouse_id", String(warehouse_id));
  }
  
  if (sort) {
    const orderingValue = order === "desc" ? `-${sort}` : sort;
    params.append("ordering", orderingValue);
  }
  if (Array.isArray(filters)) {
    filters.forEach(({ filterField, filterValue }) => {
      if (!filterField) return;

      // Date range filter
      if (typeof filterValue === "object" && filterValue !== null) {
        const { from_date, to_date } = filterValue;

        if (from_date)
          params.append(`${filterField}_from`, from_date);

        if (to_date)
          params.append(`${filterField}_to`, to_date);

        return;
      }

      // Normal filters
      params.append(filterField, String(filterValue));
    });
  }

  try {
    const response = await Axios.get(`${api?.Inventory.InStock.StockOverView.export}?${params.toString()}`, {
      params: { export: "csv" },
      responseType: "blob", // important
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Instock.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error downloading CSV", error);
  }
};
